import { render, staticRenderFns } from "./AutoSlider.vue?vue&type=template&id=8fa2c9ec&"
import script from "./AutoSlider.vue?vue&type=script&lang=js&"
export * from "./AutoSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports